export default __webpack_public_path__ + "static/media/recruit_section_image_1.7ff5f67e.webp";